
import memoizee from 'memoizee';
import * as lodash from 'lodash';
import { HttpHeaders } from '@angular/common/http';
import { CryptoVaultService } from '../services/security/crypto-vault.service';
import { ApplicationService } from '../services/application/application.service';

export enum ESortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

/**
 * Permite guardar el resultado de la ejecucion de una función en memoria teniendo en cuenta los parametros de entrada
 * Se debe tener en cuenta que esto solo se aplica a funciones estaticas que retornar el mismo valor para un conjunto de parametros determinados
 * @returns
 */
export function memoize() {
  return function (target: any, key: any, descriptor: any) {
    const oldFunction = descriptor.value;
    const newFunction = memoizee(oldFunction);
    descriptor.value = function () {
      return newFunction.apply(this, arguments);
    };
  };
}

/**
 * Permite obtener el valor de una propiedad del objeto pasado por parametro
 * @param object
 * @param property
 */
export function getValueProperty(object: any, property: string | number, defaultValue?: any) {
  const value = lodash.get(object, property, defaultValue);
  if (value && value != undefined || value === false) {
    return value;
  } else {
    return defaultValue;
  }
  /*if (object && object.hasOwnProperty(property)) {
    return object[property];
  } else {
    return defaultValue;
  }*/
}

/**
 * Permite remover los acentos de un texto
 * @param text 
 * @returns 
 */
export function removeAccents(text: string) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

/**
* Permite buscar un objeto en un arreglo de datos
* @param data Arreglo de datos
* @param property Propiedad del arreglo por la cual se debe realizar el filtro
* @param value Valor que debe tener la propiedad por la cual se desea filtrar
* @returns Elemento del arreglo de datos que coincide con los terminos de búsqueda
*/
export function findInArray(data: Array<any>, property: any, value: any) {
  let result = undefined;
  if (data && value && Array.isArray(data) && data.length > 0) {
    for (let item of data) {
      if (item && item.hasOwnProperty(property) && item[property] == value) {
        result = item;
        break;
      }
    }
  }
  return result;
}

/**
 * Permite el ordenamiento de un arreglo de objetos segun el valor de una de sus propiedades
 * @param data 
 * @param property 
 * @param order 
 * @returns 
 */
export function sortArrayObject(data: Array<any>, property: any, order: ESortDirection) {
  return data.sort((a, b) => {
    let fa = `${getValueProperty(a, property)}`.toLowerCase();
    let fb = `${getValueProperty(b, property)}`.toLowerCase();
    if ((fa < fb && order == ESortDirection.ASC) || (fa > fb && order == ESortDirection.DESC)) {
      return -1;
    }
    if ((fa > fb && order == ESortDirection.ASC) || (fa < fb && order == ESortDirection.DESC)) {
      return 1;
    }
    return 0;
  });
}

/**
 * Permite establecer el valor de una propiedad del objeto pasado por parametro
 * @param object
 * @param property
 */
export function setValueProperty(object: any, property: string | number, valueProperty?: any, applyTrim?: boolean) {
  if (applyTrim && valueProperty) {
    if (Array.isArray(valueProperty)) {
      valueProperty = valueProperty.map((item) => {
        if (Array.isArray(item)) {
          return item.map((itemArray) => `${itemArray}`.trim());
        } else {
          return `${item}`.trim();
        }
      });
    } else {
      valueProperty = `${valueProperty}`.trim()
    }
  }
  const value = lodash.set(object, property, valueProperty);
  if (value && value != undefined || value === false) {
    return value;
  } else {
    return valueProperty;
  }
}

export function lastValueFrom(observable: any) {
  return observable.toPromise();
}


export function mergeObjects(object: any, ...args: any) {
  if (!object) {
    object = {};
  }
  args.forEach((element: any) => {
    lodash.merge(object, element);
  });
  return object
}

export function isAssignedValue(object: any, isList = false, listData: any[] = [], idList = 'id') {
  let isAssignedValue = false;

  if (object !== '' && object !== undefined && object !== null && !isList) {
    isAssignedValue = true;
  } else if (isList && listData && idList) {
    let item = findInArray(listData, idList, object);
    if (item) {
      isAssignedValue = true;
    }
  }
  return isAssignedValue;
}

export async function promiseAll(data: Array<{ promise: Promise<any>, context: any, property?: string }>) {
  let promises = [];
  for (let promiseData of data) {
    promises.push(getValueProperty(promiseData, 'promise'));
  }
  try {
    let response = await Promise.all(promises);
    for (let promiseDataKey in data) {
      let promiseData = data[promiseDataKey];
      let property = getValueProperty(promiseData, 'property');
      if (property) {
        setValueProperty(data[promiseDataKey].context, property, response[promiseDataKey]);
      } else {
        data[promiseDataKey].context = response[promiseDataKey];
      }
    }
  } catch (error) {
    console.log('loadStaticValues error', error);
  }

}

export function fillString(value: string, length: number, fillChar: string = '0') {
  let zero = length - value.length + 1;
  return Array(+(zero > 0 && zero)).join(fillChar) + value;
}

export async function encrypt(_crypto: CryptoVaultService, data: any, fields: Array<string>, isHeader = false) {
  let encryptData = [];
  let dataProcess: any = {};
  if (isHeader && data) {
    let headers = data as HttpHeaders;
    for (let headerKey of headers.keys() || []) {
      dataProcess[headerKey] = headers.get(headerKey);
    }
  } else {
    dataProcess = { ...data };
  }
  for (let field of fields) {

    /**
     * Proceso encripción objeto a string
     */
    if (typeof field === 'object') {
      for (let overrideField of Object.keys(field)) {
        let valueField = getValueProperty(field, overrideField);
        let process = encriptField(_crypto, dataProcess, valueField, overrideField)
        encryptData.push(process);
      }

    } else {

      /**
       * Proceso encripcion campo a campo
       */
      /*let value = getValueProperty(dataProcess, field, '');

      if (typeof value == 'object') {
        value = JSON.stringify(value);
      }

      let process = new Promise((resolve, reject) => {
        _crypto.encrypt(value)
          .then(encrypt => {
            setValueProperty(dataProcess, field, encrypt);
            resolve(true);
          }).catch((error) => {
            reject(false);
          });
      });*/

      let process = encriptField(_crypto, dataProcess, field)
      encryptData.push(process);
    }


  }
  await Promise.all(encryptData);
  return dataProcess;
}

function encriptField(_crypto: CryptoVaultService, dataProcess: any, field: string, overrideField?: string) {

  let value = getValueProperty(dataProcess, field, '');
  if (typeof value == 'object') {
    value = JSON.stringify(value);
  }

  return new Promise((resolve, reject) => {
    _crypto.encrypt(value)
      .then(encrypt => {
        if (overrideField) {
          setValueProperty(dataProcess, overrideField, encrypt);
          setValueProperty(dataProcess, field, undefined);
        } else {
          setValueProperty(dataProcess, field, encrypt);
        }

        resolve(true);
      }).catch((error) => {
        reject(false);
      });
  });
}

export async function decrypt(_crypto: CryptoVaultService, data: string) {
  return _crypto.decrypt(data);
}

export async function centerDialog() {

  const delay = new Promise(function (resolve, reject) {
    setTimeout(function () {
      resolve('ok');
    }, 300);
  });

  await delay;

  let bounding = document?.querySelector('.voxel-dialog')?.getBoundingClientRect();
  let scrollTo = getValueProperty(bounding, 'y', 0) - getValueProperty(bounding, 'height', 0);
  window.scrollTo(0, scrollTo);

  window.parent?.scroll(0, 0);
  let boundingIframe = frameElement?.getBoundingClientRect();
  let positionYIframe = getValueProperty(boundingIframe, 'y', 0)
  let scrollToIframe = positionYIframe + scrollTo;

  window.parent?.scroll(0, scrollToIframe);

}

export function scrollTop() {
  window.scroll(0, 0);

  window.parent?.scroll(0, 0);
  let boundingIframe = frameElement?.getBoundingClientRect();
  let positionYIframe = getValueProperty(boundingIframe, 'y', 0)
  window.parent?.scroll(0, positionYIframe);
}

export function scrollBottom() {
  window.scrollTo(0, document.body.scrollHeight);
  const parent = getValueProperty(window, 'parent', false);

  if (parent) {

    let boundingIframe = frameElement?.getBoundingClientRect();
    let positionYIframe = getValueProperty(boundingIframe, 'y', 0);
    let heightIframe = getValueProperty(boundingIframe, 'height', 0);

    //parent.scroll(0, parent?.document?.body?.scrollHeight || 0);
    parent.scroll(0, heightIframe - positionYIframe || 0);
  }

}

export async function recaptchaHeaders(app: any, httpOptions: any, recaptchaSettings: any, captchaOptions: any) {

  const headerToken = getValueProperty(recaptchaSettings, "headers.token", "recaptcha_token");
  const headerValidationType = getValueProperty(recaptchaSettings, "headers.validation_type", "recaptcha_validation_type");
  const captchaToken = await app.recaptchaToken(captchaOptions);
  httpOptions.headers = httpOptions.headers.append(headerToken, `${captchaToken}`);
  httpOptions.headers = httpOptions.headers.append(headerValidationType, `${captchaOptions.action}`);

  return httpOptions;

}

export function normalizeCryptoVaultSettings(settings: { fields: string[], headers: string[], excludeInSettings?: { fields: string[], headers: string[] } }) {

  let normalize: { fields: string[], headers: string[] } = {
    fields: [],
    headers: []
  };

  normalize.fields = settings.fields
    .filter((item) =>
      ![
        ...getValueProperty(
          settings,
          'excludeInSettings.fields',
          []
        )
      ].includes(item)
    );

  normalize.headers = settings.headers
    .filter((item) =>
      ![
        ...getValueProperty(
          settings,
          'excludeInSettings.headers',
          ["recaptcha_token", "recaptcha_validation_type"]
        )
      ].includes(item)
    );
  

  return normalize;

}